import { Component, Inject, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input'; // Add this line
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatSort } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-dashboard-popup',
  standalone: true,
  imports: [MatPaginatorModule, MatInputModule, MatTableModule, MatIconModule, MatSortModule, CommonModule],
  templateUrl: './dashboard-popup.component.html',
  styleUrl: './dashboard-popup.component.scss',
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardPopupComponent {
  displayedColumns: string[] = ['employeeId', 'designation', 'fullName', 'mobileNumber'];
  functTypeList: any[] = [];
  functTypeKey: string = '';

  dataSource: any[] = [];
  paginatedData: any[] = [];
  currentPage: number = 1;
  pageSize: number = 10; // Show 10 employees per page
  totalPages: number = 1;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _mdr: MatDialogRef<DashboardPopupComponent>
  ) {}

  ngOnInit(): void {
    this.functTypeList = this.data.functTypeList;
    this.functTypeKey = this.data.functTypeKey;
    this.dataSource = this.functTypeKey
      ? this.functTypeList.filter((a) => a.designation === this.functTypeKey)
      : this.functTypeList;
  
    // Sort by latest punchDetail first
    this.dataSource.sort((a, b) => new Date(b.punchDetail).getTime() - new Date(a.punchDetail).getTime());
  
    this.totalPages = Math.ceil(this.dataSource.length / this.pageSize);
    this.updatePaginatedData();
  }
  

  applyFilter(filterValue: string): void {
    console.log('filterValue', filterValue);
    const lowerCaseFilterValue = filterValue.trim().toLowerCase();
    const filteredData = this.dataSource.filter(item =>
      (item.fullName && item.fullName.toLowerCase().includes(lowerCaseFilterValue)) ||
      (item.employeeId && item.employeeId.toString().toLowerCase().includes(lowerCaseFilterValue)) ||
      (item.designation && item.designation.toLowerCase().includes(lowerCaseFilterValue)) ||
      (item.mobileNumber && item.mobileNumber.toString().toLowerCase().includes(lowerCaseFilterValue))
    );
    this.totalPages = Math.ceil(filteredData.length / this.pageSize);
    this.currentPage = 1;
    this.updatePaginatedData(filteredData);
  }

  updatePaginatedData(data = this.dataSource): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = data.slice(startIndex, endIndex);
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedData();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedData();
    }
  }

  goToPage(page: number): void {
    this.currentPage = page;
    this.updatePaginatedData();
  }

  getPages(): (number | string)[] {
    const totalDisplayedPages = 5; // Number of page links to show
    const pages: (number | string)[] = [];
  
    if (this.totalPages <= totalDisplayedPages) {
      // If total pages are small, show all pages
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1); // Always show first page
  
      let startPage = Math.max(2, this.currentPage - 1);
      let endPage = Math.min(this.totalPages - 1, this.currentPage + 1);
  
      if (startPage > 2) {
        pages.push("...");
      }
  
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
  
      if (endPage < this.totalPages - 1) {
        pages.push("...");
      }
  
      pages.push(this.totalPages); 
    }
  
    return pages;
  }
  

  closeDialog() {
    this._mdr.close(false);
  }
}